import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'switch_toggle',
    colour: CATEGORIES.switch.color,
    textColour: '#FFFFFF',
    tooltip: 'トグルスイッチの状態を読み取ります（0: OFF, 1: FLAT, 2: ON）',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/switch_toggle.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('トグルスイッチ', { fontSize: 15, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: CATEGORIES.switch.color,
                    options: [
                        { value: 'UPPER_LEFT', label: '左上' },
                        { value: 'LOWER_LEFT', label: '左下' },
                        { value: 'UPPER_RIGHT', label: '右上' },
                        { value: 'LOWER_RIGHT', label: '右下' },
                    ],
                },
                { type: 'label', text: 'を検知する ' },
            ],
        },
    ],
});
